import React from 'react'

const Places = () => {
    return (
        <div>
            Places
        </div>
    )
}

export default Places
